import { useEffect, type ReactNode } from 'react'
import { accents, type AccentName, type ThemeName } from '@cottonray/design-tokens'
import { stylesheet } from './stylesheet'

interface ThemeProviderProps {
  children: ReactNode
  /** 지정하지 않으면 시스템 설정(prefers-color-scheme)을 따른다 */
  name?: ThemeName
  /** 서비스별 액센트. 기본은 브랜드 색(cobalt) — 예: 식집사는 'leaf' */
  accent?: AccentName
}

export function ThemeProvider({ children, name, accent = 'cobalt' }: ThemeProviderProps) {
  useEffect(() => {
    if (name === undefined) {
      delete document.documentElement.dataset.theme
    } else {
      document.documentElement.dataset.theme = name
    }
  }, [name])

  return (
    <>
      <style>{stylesheet()}</style>
      {accent !== 'cobalt' && <style>{accentOverride(accent)}</style>}
      {children}
    </>
  )
}

/** 기본(cobalt)이 아닌 액센트만 변수 4개를 덮어쓴다 — 다크/라이트 각각 */
function accentOverride(accent: AccentName): string {
  const vars = (theme: ThemeName) => {
    const set = accents[accent][theme]
    return `--st-color-accent: ${set.accent};
--st-color-accent-hover: ${set.accentHover};
--st-color-accent-surface: ${set.accentSurface};
--st-color-text-on-accent: ${set.textOnAccent};`
  }

  return `
:root { ${vars('light')} }
@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) { ${vars('dark')} }
}
:root[data-theme="dark"] { ${vars('dark')} }
:root[data-theme="light"] { ${vars('light')} }`
}
